import { reactOnCms } from 'common/js/react_on_cms';
import BookingHistory from 'components/booking_history';
import ManageBooking from 'tenants/cccsyd/booking_management/manage_booking';

reactOnCms.register({
  ManageBooking,
  BookingHistory,
});
